export const MOMENTS = [
  { value: "OPENING", label: "Apertura" },
  { value: "DURING_SHIFT", label: "Durante el turno" },
  { value: "CLOSING", label: "Cierre" },
];

export const WEEKDAYS = [
  { value: 1, label: "Lun" }, { value: 2, label: "Mar" },
  { value: 3, label: "Mié" }, { value: 4, label: "Jue" },
  { value: 5, label: "Vie" }, { value: 6, label: "Sáb" },
  { value: 7, label: "Dom" },
];

export const STATUS = {
  PENDING: { label: "Pendiente", color: "warning" },
  DONE: { label: "Completada", color: "success" },
  NOT_DONE: { label: "No realizada", color: "error" },
};

export function localYmd(date = new Date()) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function shiftYmd(ymd, amount) {
  const date = new Date(`${ymd}T12:00:00`);
  date.setDate(date.getDate() + amount);
  return localYmd(date);
}

export function momentLabel(value) {
  return MOMENTS.find((item) => item.value === value)?.label ?? value;
}

export function dateLabel(value) {
  if (!value) return "—";
  return new Intl.DateTimeFormat("es-AR", { day: "2-digit", month: "short", year: "numeric" })
    .format(new Date(`${String(value).slice(0, 10)}T12:00:00`));
}

export function timeLabel(value) {
  if (!value) return null;
  return String(value).slice(0, 5);
}

export function emptyTask() {
  return { title: "", description: "", estimatedMinutes: "", targetTime: "", steps: [] };
}
